import { ReactElement } from 'react';

import {
   DocplannerAuthenticationFault,
   DocplannerClientSecretUpdateCommand,
} from '@dreryk/egabinet-docplanner-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';

import { integrationTranslationKeys } from '../../translations';
import { DocplannerUpdateClientIdFormBean, DocplannerUpdateClientIdFormController } from '../integration.types';

type DocplannerUpdateClientSecretCommandOptions = {
   onSuccess: VoidFunction;
   onIncorrectPasswordFault: VoidFunction;
};

const useUpdateClientSecretCommand = (
   options: DocplannerUpdateClientSecretCommandOptions
): UseCqrsCommandResult<void, DocplannerUpdateClientIdFormBean, DocplannerAuthenticationFault> => {
   return useCqrsCommand(
      (parameters) => {
         const command = new DocplannerClientSecretUpdateCommand();
         command.clientSecret = parameters.newApiSecret!;
         return command;
      },
      {
         onSuccess: () => {
            options.onSuccess();
            dispatchSnackbarPositiveEvent(integrationTranslationKeys.passwordHasBeenUpdated);
         },
         onFault: {
            'egabinet-docplanner-frontend-api:DocplannerAuthenticationFault': options.onIncorrectPasswordFault,
         },
      }
   );
};

type DocplannerUpdateClientSecretConfirmButtonProps = {
   readonly onSuccess: VoidFunction;
   readonly setNewApiSecretError: VoidFunction;
   readonly handleSubmit: DocplannerUpdateClientIdFormController['handleSubmit'];
};

export const DocplannerUpdateClientSecretConfirmButton = (
   props: DocplannerUpdateClientSecretConfirmButtonProps
): ReactElement => {
   const { executeAsync: updateClientSecret } = useUpdateClientSecretCommand({
      onSuccess: props.onSuccess,
      onIncorrectPasswordFault: props.setNewApiSecretError,
   });
   return (
      <ModalConfirmButton
         testId={'updateClientSecret'}
         label={integrationTranslationKeys.save}
         onClick={props.handleSubmit(updateClientSecret)}
         blockingOperation
      />
   );
};
